/** Pixel height of an appointment block on the day grid. */
export function appointmentSlotHeight(rowHeight: number, durationHours: number): number {
  return Math.max(rowHeight * durationHours - 5, 0);
}

/** Single-row layout when the time block is shorter than ~35 minutes at default density. */
export function isCompactAppointmentSlot(rowHeight: number, durationHours: number): boolean {
  return appointmentSlotHeight(rowHeight, durationHours) < 58;
}

export function statusShortLabel(label: string): string {
  const upper = label.toUpperCase();
  if (upper === 'CONFIRMED') return 'Conf';
  if (upper === 'SCHEDULED') return 'Sch';
  if (upper === 'PENDING') return 'Pend';
  if (upper === 'CHECKED IN' || upper === 'CHECKED_IN') return 'In';
  if (label.length <= 5) return label;
  return label.slice(0, 4);
}
